import React, { useState, useEffect, useRef } from "react";
import { Layout, Input, Skeleton, BackTop } from "antd";
import "./index.scss";
import axiosInstance from "@/axios/axiosInstance";
import _ from "lodash";

const { Header, Footer } = Layout;
const PAGE_SIZE = 10; // 每页加载10条数据

const Industrynews = () => {
  // 假设这是你的图片数组
  // let insDefuelt = [
  //   {
  //     title: "AI 助力新药研发取得重大突破",
  //     cover: require(`./img/10.png`),
  //     content:
  //       "最新研究表明，某 AI 技术成功缩短新药研发周期达 30%，大大降低了研发成本，为医药行业带来革命性变革。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-11-30",
  //     label: "AI, 医药,研发突破",
  //   },
  //   {
  //     title: "全球首个 AI 驱动的智慧城市项目落地",
  //     cover: require(`./img/16.png`),
  //     content:
  //       "一座全新的智慧城市在 [城市名称] 建成，该城市全方位运用 AI 技术实现能源高效利用、交通智能疏导等功能。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-11-25",
  //     label: "AI, 智慧城市,城市建设",
  //   },
  //   {
  //     title: "AI 绘画引发艺术界新变革",
  //     cover: require("./img/baa9dd75-2e81-4c26-be01-a2f4e291944b_1736402686040575995_origin~tplv-a9rns2rl98-web-thumb.jpg"),
  //     content:
  //       "AI 绘画作品在各大艺术展览中频繁亮相，引发了关于艺术创作本质的广泛讨论。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-11-20",
  //     label: "AI, 绘画,艺术变革",
  //   },
  //   {
  //     title: "大型科技公司发布新一代 AI 芯片",
  //     cover: "require('./img/13.png')",
  //     content:
  //       "[公司名称] 推出的新一代 AI 芯片，性能相较于上一代提升了 50%，为 AI 应用提供更强大的算力支持。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-11-15",
  //     label: "AI, 芯片,科技公司",
  //   },
  //   {
  //     title: "AI 教育产品广泛应用于校园",
  //     cover: "require('./img/14.png')",
  //     content:
  //       "多款 AI 教育产品进入校园，帮助教师实现个性化教学，提高学生学习效率。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-11-10",
  //     label: "AI, 教育,校园应用",
  //   },
  //   {
  //     title: "AI 技术提升制造业质量检测精度",
  //     cover: "require('./img/15.png')",
  //     content:
  //       "制造业引入 AI 技术进行质量检测，将检测精度从 90% 提升至 98%，有效减少次品率。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-11-05",
  //     label: "AI, 制造业,质量检测",
  //   },
  //   {
  //     title: "AI 客服在电商领域全面升级",
  //     cover: "require('./img/16.png')",
  //     content:
  //       "电商平台的 AI 客服经过升级，能够更精准、快速地回答用户问题，用户满意度提升 20%。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-10-30",
  //     label: "AI, 电商,客服升级",
  //   },
  //   {
  //     title: "AI 辅助医疗诊断系统获批上市",
  //     cover: "require('./img/17.png')",
  //     content:
  //       "一款 AI 辅助医疗诊断系统获得监管部门批准上市，为医生提供更准确的诊断建议。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-10-25",
  //     label: "AI, 医疗,诊断系统",
  //   },
  //   {
  //     title: "自动驾驶 AI 算法取得关键进展",
  //     cover: "require('./img/18.png')",
  //     content:
  //       "研究人员在自动驾驶 AI 算法方面取得突破，提高了自动驾驶在复杂路况下的安全性。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-10-20",
  //     label: "AI, 自动驾驶,算法进展",
  //   },
  //   {
  //     title: "AI 助力环保领域实现精准监测",
  //     cover: "require('./img/19.png')",
  //     content:
  //       "通过 AI 技术，环保部门能够对环境污染进行实时、精准监测，及时采取应对措施。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-10-15",
  //     label: "AI, 环保,精准监测",
  //   },
  //   {
  //     title: "AI 语音助手功能大幅增强",
  //     cover: "require('./img/20.png')",
  //     content:
  //       "主流 AI 语音助手新增多种实用功能，如智能日程安排、多语言实时翻译等。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-10-10",
  //     label: "AI, 语音助手,功能增强",
  //   },
  //   {
  //     title: "AI 驱动的金融风险预警系统上线",
  //     cover: "require('./img/21.png')",
  //     content:
  //       "金融机构采用 AI 驱动的风险预警系统，提前识别潜在风险，保障金融市场稳定。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-10-05",
  //     label: "AI, 金融,风险预警",
  //   },
  //   {
  //     title: "AI 设计工具受到设计师广泛欢迎",
  //     cover: "require('./img/22.png')",
  //     content:
  //       "一款全新的 AI 设计工具在设计师群体中迅速流行，提高设计效率达 40%。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-09-30",
  //     label: "AI, 设计工具,设计行业",
  //   },
  //   {
  //     title: "AI 农业技术促进粮食增产",
  //     cover: "require('./img/23.png')",
  //     content:
  //       "在 [地区名称] 推广的 AI 农业技术，帮助农民实现粮食增产 15%，保障粮食安全。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-09-25",
  //     label: "AI, 农业,粮食增产",
  //   },
  //   {
  //     title: "AI 与区块链技术融合应用探索",
  //     cover: "require('./img/24.png')",
  //     content:
  //       "研究人员开始探索 AI 与区块链技术的融合应用，有望在数据安全、信任机制等方面取得创新。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-09-20",
  //     label: "AI, 区块链,技术融合",
  //   },
  //   {
  //     title: "AI 虚拟人进入娱乐直播行业",
  //     cover: "require('./img/25.png')",
  //     content:
  //       "AI 虚拟人主播在娱乐直播平台亮相，吸引大量观众，为直播行业带来新的活力。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-09-15",
  //     label: "AI, 虚拟人,娱乐直播",
  //   },
  //   {
  //     title: "AI 数据安全技术取得新突破",
  //     cover: "require('./img/26.png')",
  //     content:
  //       "一项新的 AI 数据安全技术诞生，有效防止数据泄露，保护企业和用户数据安全。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-09-10",
  //     label: "AI, 数据安全,技术突破",
  //   },
  //   {
  //     title: "AI 助力航天探索任务",
  //     cover: "require('./img/27.png')",
  //     content:
  //       "在最新的航天探索任务中，AI 技术用于数据分析和决策支持，提高任务成功率。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-09-05",
  //     label: "AI, 航天,探索任务",
  //   },
  //   {
  //     title: "AI 游戏开发技术崭露头角",
  //     cover: "require('./img/28.png')",
  //     content:
  //       "采用 AI 技术开发的游戏在玩法创新和用户体验方面表现出色，受到玩家喜爱。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-08-30",
  //     label: "AI, 游戏开发,游戏行业",
  //   },
  //   {
  //     title: "AI 助力文化遗产保护与修复",
  //     cover: "require('./img/29.png')",
  //     content:
  //       "利用 AI 技术对文化遗产进行数字化保护和修复，让珍贵的文化遗产得以长久保存。",
  //     createUserName: "AI 资讯团队",
  //     createTime: "2024-07-01",
  //     label: "AI, 文化遗产,保护修复",
  //   },
  //   {
  //     title: "零就业保障、全天精神“酷刑”！ChatGPT 类产品背后 80% 贡献",
  //     cover: require(`./img/1.png`),
  //     content:
  //       "我们的体力被榨干、精神也被榨干，每天活得如同行尸走肉。”轮班时间很长，工人们必须在必须在速度和准确性方面满足严格的绩效要求。",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  //   {
  //     title: "网易员工内部群怼丁磊：人人陪你演戏点赞；李彦宏：开源模型是",
  //     cover: require(`./img/2.png`),
  //     content:
  //       "李彦宏认为开源其实是一种智商税；赛力斯发公告，宣布要以 25 亿元人民币收购华为持有的问界部分；天兵科技就火箭坠落致歉；英伟达将因涉嫌违反市场竞争行为受到法国反垄断机...",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  //   {
  //     title: "80如何借助数学打造更好的 AI 算法基础并消除大模型幻觉？",
  //     cover: require(`./img/3.png`),
  //     content: "人工智能的作用不仅仅是预测，而是拥有影响世界的决策能力",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  //   {
  //     title: "隐私计算被推向新高度！信通院牵头编写《隐私计算产品通用安全",
  //     cover: require(`./img/4.png`),
  //     content:
  //       "如何让大规模高价值数据可信流通，成为数据要素市场发展的核心议题，亟需产学研届共同构建新的技术标准体系。7 月 5 日，在 2024 世界人工智能大会上，围绕隐私计算产品通用安",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  //   {
  //     title: "面壁 WAIC 新发布：新一代高效低能耗架构面壁小钢炮、一键开发",
  //     cover: require(`./img/5.png`),
  //     content:
  //       "开源新一代高效、低能耗面壁小钢炮 MiniCPM-S 模型、助力开发者一键打造大模型 SuperAPP 的全栈工具集 MobileCPM",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  //   {
  //     title: "创新、更有温度！从极客马拉松的星星之火，看鸿蒙世界的璀璨星",
  //     cover: require(`./img/6.png`),
  //     content:
  //       "Apache Hive是一个分布式、容错的数据仓库系统，可实现大规模分析和 有助于使用 SQL 读取、写入和管理驻留在分布式存储",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  //   {
  //     title: "2024 世界人工智能大会（WAIC）开幕，图灵得主巅峰聚首共商AI",
  //     cover: require(`./img/7.png`),
  //     content:
  //       "Apache Hive是一个分布式、容错的数据仓库系统，可实现大规模分析和 有助于使用 SQL 读取、写入和管理驻留在分布式存储",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  //   {
  //     title: "2024 年过半，AI 大模型在各行业的落地实践走到哪了？",
  //     cover: require(`./img/8.png`),
  //     content:
  //       "Apache Hive是一个分布式、容错的数据仓库系统，可实现大规模分析和 有助于使用 SQL 读取、写入和管理驻留在分布式存储",
  //     createUserName: "ChatGPT",
  //     createTime: "2024-6-29",
  //   },
  // ];

  // 控制展开/收起状态，使用面板的key作为activeKey
  const [qiyData, setqiyData] = useState([]);
  const [dataSet, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [showDefaultData, setShowDefaultData] = useState(false);
  const loadingRef = useRef(null);

  // 获取数据的函数
  const getData = async (a, pageNum = 1) => {
    setLoading(true);
    let param = `title=${a || ""}&page=${pageNum}&limit=${PAGE_SIZE}`;
    try {
      const response = await axiosInstance.get(
        `/information/page/list?${param}`
      );
      let compute = response.data.data;
      const total = response.data.page.totalCount;

      if (pageNum === 1) {
        setTotalCount(total);
      }

      if (compute.length > 0) {
        setData((prev) => (pageNum === 1 ? compute : [...prev, ...compute]));
        // 检查是否还有更多数据
        const currentTotal =
          (pageNum === 1 ? 0 : dataSet.length) + compute.length;
        setHasMore(currentTotal < total);

        // 如果加载完所有API数据，显示默认数据
        if (currentTotal >= total) {
          // setShowDefaultData(true);
        }
      } else {
        setHasMore(false);
        // setShowDefaultData(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasMore(false);
      // setShowDefaultData(true);
    } finally {
      setLoading(false);
    }
  };
  // 处理滚动加载
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
          // 检查是否还需要加载更多
          if (dataSet.length < totalCount) {
            setPage((prev) => prev + 1);
          }
        }
      },
      { threshold: 0.5 }
    );

    if (loadingRef.current) {
      observer.observe(loadingRef.current);
    }

    return () => observer.disconnect();
  }, [hasMore, loading, dataSet.length, totalCount]);
  // 监听页码变化
  useEffect(() => {
    if (page > 1) {
      getData("", page);
    }
  }, [page]);

  // 初始加载
  useEffect(() => {
    getData("", 1);
    getqiyData();
    document.title =
      "渐风AI,人工智能产业资讯,AI行业报道,AI新闻,AI企业名录,人工智能企业名录,人工智能会议,人工智能行业活动,AI活动,AI会议,AI企业100强,AI企业50强";
  }, []);
  // 渲染新闻项
  const renderNewsItem = (item) => (
    <div className="cont-san" key={item.title} onClick={() => toDetail(item)}>
      <div className="cont-l">
        <img src={item.cover} alt="" />
      </div>
      <div className="cont-r">
        <div className="concent">{item.title}</div>
        <div className="child send">
          <div className="label">
            {item.label &&
              item.label.split(",").map((labelItem, index) => (
                <span key={index} className="label-item">
                  {labelItem.trim()}
                </span>
              ))}
          </div>
          <span>
            <span>{item.createUserName} </span>
            <span className="nickName">{item.createTime.split(" ")[0]}</span>
          </span>
        </div>
      </div>
    </div>
  );

  // 渲染骨架屏
  const renderSkeleton = () => (
    <div className="cont-san">
      <div className="cont-l">
        <Skeleton.Image active style={{ width: 115, height: 81 }} />
      </div>
      <div className="cont-r">
        <Skeleton active paragraph={{ rows: 2 }} />
      </div>
    </div>
  );

  const getqiyData = async () => {
    try {
      const response = await axiosInstance.get(
        `/vendorManager/index/list?limit=12&page=1`
      );
      setqiyData(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const debouncedFetchData = _.debounce(getData, 1000);

  const handleSearch = (value) => {
    console.log("Searching for:", value);
    debouncedFetchData(value);
  };
  const huData = [
    {
      title: "CEAI 2025中国具身智能大会",
      logoUrl: require(`./img/11.png`),
      ads: "北京",
      time: "2025年3月28-30日",
      url: "https://www.163.com/dy/article/JKEIFF170511PEBT.html ",
    },
    {
      title: "2025年具身智能机器人发展大会",
      logoUrl: require(`./img/12.png`),
      ads: "天津",
      time: "2025年3月7日",
      url: " https://mp.weixin.qq.com/s?__biz=MjM5MDUxNjI1NQ==&mid=2650361301&idx=1&sn=f8fceb3ee7e9d47d24f5ecb799351d6d&chksm=be4e78a58939f1b345769905b1d9f2d4251689de566a6f510eb42e8b6b292da5162d860c62c6&scene=27 ",
    },
    {
      title: "WAIC世界人工智能大会",
      logoUrl: require(`./img/13.png`),
      ads: "上海",
      time: "2025年6月（预计）",
      url: " https://www.worldaic.com.cn ",
    },
    {
      title: "2025深圳（国际）通用人工智能大会",
      logoUrl: require(`./img/14.png`),
      ads: "深圳",
      time: "2025年8月27日-29日",
      url: "https://www.agicexpo.com/?bd_vid=1462386112944800855",
    },
    {
      title: "2025年大数据、人工智能与数字经济国际学术会议",
      logoUrl: require(`./img/15.png`),
      ads: "昆明",
      time: "2025年7月18日-20日",
      url: "http://www.comeonbb.com/index/learning/content/29IA2E",
    },
  ];
  const toDetail = (record) => {
    // 构建 URL 参数
    if (record.informationId) {
      const params = new URLSearchParams({
        id: record.informationId,
        // profilePictureUrl: record.profilePictureUrl,
        // nickName: record.nickName,
      });
      const url = `/industry_detail?${params.toString()}`;
      window.open(url, "_blank"); // 在新窗口或新标签页中打开
    }
  };
  return (
    <div>
      <Layout className="industry">
        <Header className="industry-hea">
          <Input
            placeholder="搜索"
            style={{ width: "300px", marginTop: "16px" }}
            onChange={(e) => {
              setPage(1);
              setShowDefaultData(false);
              setTotalCount(0);
              setData([]);
              debouncedFetchData(e.target.value);
            }}
            allowClear
            onPressEnter={(e) => handleSearch(e.target.value)}
          />
        </Header>
        <Footer className="industryfoot">
          <div className="left">
            {loading && page === 1 ? (
              Array(3)
                .fill()
                .map((_, index) => (
                  <React.Fragment key={index}>
                    {renderSkeleton()}
                  </React.Fragment>
                ))
            ) : (
              <>
                {/* API数据 */}
                {dataSet.map(renderNewsItem)}

                {/* 加载更多的骨架屏 */}
                {hasMore && dataSet.length < totalCount && (
                  <div
                    ref={loadingRef}
                    style={{ padding: "20px 0", textAlign: "center" }}
                  >
                    {loading ? renderSkeleton() : null}
                  </div>
                )}

                {/* 显示加载进度 */}
                {dataSet.length > 0 && !showDefaultData && (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#999",
                      padding: "10px 0",
                    }}
                  >
                    {/* {dataSet.length} / {totalCount} */}
                  </div>
                )}

                {/* API数据加载完成后显示默认数据 */}
                {showDefaultData && (
                  <>
                    <div
                      className="default-data-divider"
                      style={{
                        margin: "20px 0",
                        textAlign: "center",
                        color: "#999",
                        fontSize: "14px",
                      }}
                    >
                      更多资讯
                    </div>
                    {/* {insDefuelt.map(renderNewsItem)} */}
                  </>
                )}
              </>
            )}
          </div>
          <div className="right">
            <div className="right_top">
              <div className="top">会议活动</div>
              <div className="cont">
                {huData.map((v, index) => {
                  return (
                    <div className="cont-san" key={v.title}>
                      <div className="cont-l">
                        <img src={v.logoUrl} alt="" />
                      </div>
                      <div className="cont-r">
                        <div className="concent">{v.title}</div>
                        <div className="cont">
                          <span>{v.ads} </span>
                          <span className="nickName">{v.time}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="right_bot">
              <div className="top">
                <span>产业名录</span>
                <span className="more">查看更多</span>
              </div>
              <div className="cont">
                {qiyData.map((v, index) => {
                  return (
                    <div className="cont-san" key={v.name}>
                      <div className="cont-l">
                        <img src={v.logoUrl} alt="" />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Footer>
      </Layout>
      <BackTop />
    </div>
  );
};

export default Industrynews;
